import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 5px 10px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  @media (${mobileXXLargeMax}) {
    padding: 0 3px 60px 3px;
  }
`;

export const ImageRow = styled.div`
  display: flex;
  margin-top: 10px;

  @media (${mobileXXLargeMax}) {
    margin-top: 6px;
  }
`;

export const PropertyImage = styled.img`
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;

  @media (${mobileXXLargeMax}) {
    padding-left: 3px;
    padding-right: 3px;
  }
`;
